import React from 'react';
import ReactTooltip from 'react-tooltip'
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { InfoIcon } from 'common/components/icons'


const tooltipStyleSheet = {
    tooltipWrapper: {
        '& > div': {
            opacity: '1 !important',
            padding: "6px 9px",
            fontSize: 12,

        }
    },
    tooltipBox: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        boxShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
        maxWidth: 280,
        whiteSpace: 'normal',
        borderRadius: 2,
    },
    tooltipText: {
        color: '#ffffff',
    },
};

const TooltipComponent = ({ classes, id, children, ...props }) => {
    return (
        <div className={classes.tooltipWrapper}>
            <ReactTooltip className={classes.tooltipBox} id={id} type="Dark" effect="solid" {...props}>
                <div className={classes.tooltipText}>
                    {children}
                </div>
            </ReactTooltip>
        </div>
    )
}

export default withStyles(tooltipStyleSheet, { name: 'TooltipComponent' })(TooltipComponent);


const materialTooltipStylesheet = {
    tooltip: {
        fontSize: 12,
        fontWeight: '400',
        backgroundColor: 'rgba(0,0,0,0.7)',
        boxShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
        borderRadius: 2,
        maxWidth: '300px',
        color: '#ffffff',
        opacity: '1',
        padding: '5px 10px'
    },
};

const _MCudaTooltip = ({ classes, children, title, placement = 'top' }) => {
    return (
        <Tooltip
            title={title}
            placement={placement}
            classes={classes}
            // See https://github.com/mui-org/material-ui/issues/10735
            PopperProps={{ style: { pointerEvents: 'none' } }}
        >
            {children}
        </Tooltip>
    )
}

const MCudaTooltip = withStyles(materialTooltipStylesheet, { name: 'materialTooltipStylesheet' })(_MCudaTooltip);
export { MCudaTooltip };


const infoTooltipStylesheet = {
    root: {
        '& svg': {
            marginTop: '4px',
            marginLeft: '10px'
        }
    }
};

export const _CudaInfoTooltip = ({ classes, title }) => (
    <span className={classes.root}>
        <MCudaTooltip title={<span dangerouslySetInnerHTML={{ __html: title }}/>}>
            <InfoIcon />
        </MCudaTooltip>
    </span>
)
export const CudaInfoTooltip = withStyles(infoTooltipStylesheet, { name: 'materialTooltipStylesheet' })(_CudaInfoTooltip);

